import { createApp } from 'vue'
import App from './App.vue'
import router from './baseUtils/router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import common from './utils/common'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import 'amfe-flexible/index.js'
import Icon from './components/icon/symbolIcon.vue'
import './assets/iconfont/iconfont.js'
import 'animate.css'
import './utils/flexible'
import './styles/global.less'
import './styles/init.less'
import './styles/index.less'
import { WENGE_LANG } from './lang/wengeLang.js'
import Player, { I18N } from 'xgplayer'
import './styles/xgplayer.css' // 引入西瓜视频样式
import i18nPlugin from './locales'
import clickOutside from './baseUtils/clickOutside'
//必须引入的核心
import Recorder from 'recorder-core'

//引入mp3格式支持文件；如果需要多个格式支持，把这些格式的编码引擎js文件放到后面统统引入进来即可
import 'recorder-core/src/engine/mp3'
import 'recorder-core/src/engine/mp3-engine'
//录制wav格式的用这一句就行
import 'recorder-core/src/engine/wav'

//可选的插件支持项，这个是波形可视化插件
import 'recorder-core/src/extensions/waveview'
// import Guide from './components/Guide/index.vue'
import tutorialPlugin from '@/utils/tutorialPlugin'
const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(tutorialPlugin)
// 视频播放器
I18N.use(WENGE_LANG)

// 创建 pinia 实例，并将其挂载到全局
app.use(router).use(pinia).use(Recorder)
app.use(i18nPlugin)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component)
}
// 将封装的 Axios 实例挂载到全局
// app.config.globalProperties.$axios = axios;
// utils挂载全局
app.config.globalProperties.$common = common
app.component('Icon', Icon)
// 注册全局组件
// app.component('Guide', Guide)
app.directive('click-outside', clickOutside)
app.mount('#app')
